import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/modules/material.module';

import { TransferPlaceholderActionComponent } from './transfer-placeholder-action/transfer-placeholder-action.component';

const COMPONENTS = [TransferPlaceholderActionComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, MaterialModule],
  exports: COMPONENTS,
})
export class MasterSuiteActionsModule {}
